import {
  mountOnboardingForm,
  priorityOptions,
} from "components/onboarding_form";

const professionalClientRequiredGroups = [
  ["professional_client.understanding", "professional_client.work"],
  [
    "professional_client.generally",
    "professional_client.shares",
    "professional_client.unit",
  ],
];

const countryOptions = [
  { label: "Afghanistan", value: "AFG" },
  { label: "Åland Islands", value: "ALA" },
  { label: "Albania", value: "ALB" },
  { label: "Algeria", value: "DZA" },
  { label: "American Samoa", value: "ASM" },
  { label: "Andorra", value: "AND" },
  { label: "Angola", value: "AGO" },
  { label: "Anguilla", value: "AIA" },
  { label: "Antarctica", value: "ATA" },
  { label: "Antigua and Barbuda", value: "ATG" },
  { label: "Argentina", value: "ARG" },
  { label: "Armenia", value: "ARM" },
  { label: "Aruba", value: "ABW" },
  { label: "Australia", value: "AUS" },
  { label: "Austria", value: "AUT" },
  { label: "Azerbaijan", value: "AZE" },
  { label: "Bahamas", value: "BHS" },
  { label: "Bahrain", value: "BHR" },
  { label: "Bangladesh", value: "BGD" },
  { label: "Barbados", value: "BRB" },
  { label: "Belarus", value: "BLR" },
  { label: "Belgium", value: "BEL" },
  { label: "Belize", value: "BLZ" },
  { label: "Benin", value: "BEN" },
  { label: "Bermuda", value: "BMU" },
  { label: "Bhutan", value: "BTN" },
  { label: "Bolivia, Plurinational State of", value: "BOL" },
  { label: "Bonaire, Sint Eustatius and Saba", value: "BES" },
  { label: "Bosnia and Herzegovina", value: "BIH" },
  { label: "Botswana", value: "BWA" },
  { label: "Bouvet Island", value: "BVT" },
  { label: "Brazil", value: "BRA" },
  { label: "British Indian Ocean Territory", value: "IOT" },
  { label: "Brunei Darussalam", value: "BRN" },
  { label: "Bulgaria", value: "BGR" },
  { label: "Burkina Faso", value: "BFA" },
  { label: "Burundi", value: "BDI" },
  { label: "Cabo Verde", value: "CPV" },
  { label: "Cambodia", value: "KHM" },
  { label: "Cameroon", value: "CMR" },
  { label: "Canada", value: "CAN" },
  { label: "Cayman Islands", value: "CYM" },
  { label: "Central African Republic", value: "CAF" },
  { label: "Chad", value: "TCD" },
  { label: "Chile", value: "CHL" },
  { label: "China", value: "CHN" },
  { label: "Christmas Island", value: "CXR" },
  { label: "Cocos (Keeling) Islands", value: "CCK" },
  { label: "Colombia", value: "COL" },
  { label: "Comoros", value: "COM" },
  { label: "Congo", value: "COG" },
  { label: "Congo, Democratic Republic of the", value: "COD" },
  { label: "Cook Islands", value: "COK" },
  { label: "Costa Rica", value: "CRI" },
  { label: "Croatia", value: "HRV" },
  { label: "Cuba", value: "CUB" },
  { label: "Curaçao", value: "CUW" },
  { label: "Cyprus", value: "CYP" },
  { label: "Czechia", value: "CZE" },
  { label: "Côte d'Ivoire", value: "CIV" },
  { label: "Denmark", value: "DNK" },
  { label: "Djibouti", value: "DJI" },
  { label: "Dominica", value: "DMA" },
  { label: "Dominican Republic", value: "DOM" },
  { label: "Ecuador", value: "ECU" },
  { label: "Egypt", value: "EGY" },
  { label: "El Salvador", value: "SLV" },
  { label: "Equatorial Guinea", value: "GNQ" },
  { label: "Eritrea", value: "ERI" },
  { label: "Estonia", value: "EST" },
  { label: "Eswatini", value: "SWZ" },
  { label: "Ethiopia", value: "ETH" },
  { label: "Falkland Islands (Malvinas)", value: "FLK" },
  { label: "Faroe Islands", value: "FRO" },
  { label: "Fiji", value: "FJI" },
  { label: "Finland", value: "FIN" },
  { label: "France", value: "FRA" },
  { label: "French Guiana", value: "GUF" },
  { label: "French Polynesia", value: "PYF" },
  { label: "French Southern Territories", value: "ATF" },
  { label: "Gabon", value: "GAB" },
  { label: "Gambia", value: "GMB" },
  { label: "Georgia", value: "GEO" },
  { label: "Germany", value: "DEU" },
  { label: "Ghana", value: "GHA" },
  { label: "Gibraltar", value: "GIB" },
  { label: "Greece", value: "GRC" },
  { label: "Greenland", value: "GRL" },
  { label: "Grenada", value: "GRD" },
  { label: "Guadeloupe", value: "GLP" },
  { label: "Guam", value: "GUM" },
  { label: "Guatemala", value: "GTM" },
  { label: "Guernsey", value: "GGY" },
  { label: "Guinea", value: "GIN" },
  { label: "Guinea-Bissau", value: "GNB" },
  { label: "Guyana", value: "GUY" },
  { label: "Haiti", value: "HTI" },
  { label: "Heard Island and McDonald Islands", value: "HMD" },
  { label: "Holy See", value: "VAT" },
  { label: "Honduras", value: "HND" },
  { label: "Hong Kong", value: "HKG" },
  { label: "Hungary", value: "HUN" },
  { label: "Iceland", value: "ISL" },
  { label: "India", value: "IND" },
  { label: "Indonesia", value: "IDN" },
  { label: "Iran, Islamic Republic of", value: "IRN" },
  { label: "Iraq", value: "IRQ" },
  { label: "Ireland", value: "IRL" },
  { label: "Isle of Man", value: "IMN" },
  { label: "Israel", value: "ISR" },
  { label: "Italy", value: "ITA" },
  { label: "Jamaica", value: "JAM" },
  { label: "Japan", value: "JPN" },
  { label: "Jersey", value: "JEY" },
  { label: "Jordan", value: "JOR" },
  { label: "Kazakhstan", value: "KAZ" },
  { label: "Kenya", value: "KEN" },
  { label: "Kiribati", value: "KIR" },
  { label: "Korea, Democratic People's Republic of", value: "PRK" },
  { label: "Korea, Republic of", value: "KOR" },
  { label: "Kuwait", value: "KWT" },
  { label: "Kyrgyzstan", value: "KGZ" },
  { label: "Lao People's Democratic Republic", value: "LAO" },
  { label: "Latvia", value: "LVA" },
  { label: "Lebanon", value: "LBN" },
  { label: "Lesotho", value: "LSO" },
  { label: "Liberia", value: "LBR" },
  { label: "Libya", value: "LBY" },
  { label: "Liechtenstein", value: "LIE" },
  { label: "Lithuania", value: "LTU" },
  { label: "Luxembourg", value: "LUX" },
  { label: "Macao", value: "MAC" },
  { label: "Madagascar", value: "MDG" },
  { label: "Malawi", value: "MWI" },
  { label: "Malaysia", value: "MYS" },
  { label: "Maldives", value: "MDV" },
  { label: "Mali", value: "MLI" },
  { label: "Malta", value: "MLT" },
  { label: "Marshall Islands", value: "MHL" },
  { label: "Martinique", value: "MTQ" },
  { label: "Mauritania", value: "MRT" },
  { label: "Mauritius", value: "MUS" },
  { label: "Mayotte", value: "MYT" },
  { label: "Mexico", value: "MEX" },
  { label: "Micronesia, Federated States of", value: "FSM" },
  { label: "Moldova, Republic of", value: "MDA" },
  { label: "Monaco", value: "MCO" },
  { label: "Mongolia", value: "MNG" },
  { label: "Montenegro", value: "MNE" },
  { label: "Montserrat", value: "MSR" },
  { label: "Morocco", value: "MAR" },
  { label: "Mozambique", value: "MOZ" },
  { label: "Myanmar", value: "MMR" },
  { label: "Namibia", value: "NAM" },
  { label: "Nauru", value: "NRU" },
  { label: "Nepal", value: "NPL" },
  { label: "Netherlands, Kingdom of the", value: "NLD" },
  { label: "New Caledonia", value: "NCL" },
  { label: "New Zealand", value: "NZL" },
  { label: "Nicaragua", value: "NIC" },
  { label: "Niger", value: "NER" },
  { label: "Nigeria", value: "NGA" },
  { label: "Niue", value: "NIU" },
  { label: "Norfolk Island", value: "NFK" },
  { label: "North Macedonia", value: "MKD" },
  { label: "Northern Mariana Islands", value: "MNP" },
  { label: "Norway", value: "NOR" },
  { label: "Oman", value: "OMN" },
  { label: "Pakistan", value: "PAK" },
  { label: "Palau", value: "PLW" },
  { label: "Palestine, State of", value: "PSE" },
  { label: "Panama", value: "PAN" },
  { label: "Papua New Guinea", value: "PNG" },
  { label: "Paraguay", value: "PRY" },
  { label: "Peru", value: "PER" },
  { label: "Philippines", value: "PHL" },
  { label: "Pitcairn", value: "PCN" },
  { label: "Poland", value: "POL" },
  { label: "Portugal", value: "PRT" },
  { label: "Puerto Rico", value: "PRI" },
  { label: "Qatar", value: "QAT" },
  { label: "Romania", value: "ROU" },
  { label: "Russian Federation", value: "RUS" },
  { label: "Rwanda", value: "RWA" },
  { label: "Réunion", value: "REU" },
  { label: "Saint Barthélemy", value: "BLM" },
  { label: "Saint Helena, Ascension and Tristan da Cunha", value: "SHN" },
  { label: "Saint Kitts and Nevis", value: "KNA" },
  { label: "Saint Lucia", value: "LCA" },
  { label: "Saint Martin (French part)", value: "MAF" },
  { label: "Saint Pierre and Miquelon", value: "SPM" },
  { label: "Saint Vincent and the Grenadines", value: "VCT" },
  { label: "Samoa", value: "WSM" },
  { label: "San Marino", value: "SMR" },
  { label: "Sao Tome and Principe", value: "STP" },
  { label: "Saudi Arabia", value: "SAU" },
  { label: "Senegal", value: "SEN" },
  { label: "Serbia", value: "SRB" },
  { label: "Seychelles", value: "SYC" },
  { label: "Sierra Leone", value: "SLE" },
  { label: "Singapore", value: "SGP" },
  { label: "Sint Maarten (Dutch part)", value: "SXM" },
  { label: "Slovakia", value: "SVK" },
  { label: "Slovenia", value: "SVN" },
  { label: "Solomon Islands", value: "SLB" },
  { label: "Somalia", value: "SOM" },
  { label: "South Africa", value: "ZAF" },
  { label: "South Georgia and the South Sandwich Islands", value: "SGS" },
  { label: "South Sudan", value: "SSD" },
  { label: "Spain", value: "ESP" },
  { label: "Sri Lanka", value: "LKA" },
  { label: "Sudan", value: "SDN" },
  { label: "Suriname", value: "SUR" },
  { label: "Svalbard and Jan Mayen", value: "SJM" },
  { label: "Sweden", value: "SWE" },
  { label: "Switzerland", value: "CHE" },
  { label: "Syrian Arab Republic", value: "SYR" },
  { label: "Taiwan, Province of China", value: "TWN" },
  { label: "Tajikistan", value: "TJK" },
  { label: "Tanzania, United Republic of", value: "TZA" },
  { label: "Thailand", value: "THA" },
  { label: "Timor-Leste", value: "TLS" },
  { label: "Togo", value: "TGO" },
  { label: "Tokelau", value: "TKL" },
  { label: "Tonga", value: "TON" },
  { label: "Trinidad and Tobago", value: "TTO" },
  { label: "Tunisia", value: "TUN" },
  { label: "Turkmenistan", value: "TKM" },
  { label: "Turks and Caicos Islands", value: "TCA" },
  { label: "Tuvalu", value: "TUV" },
  { label: "Türkiye", value: "TUR" },
  { label: "Uganda", value: "UGA" },
  { label: "Ukraine", value: "UKR" },
  { label: "United Arab Emirates", value: "ARE" },
  {
    label: "United Kingdom of Great Britain and Northern Ireland",
    value: "GBR",
  },
  { label: "United States Minor Outlying Islands", value: "UMI" },
  { label: "United States of America", value: "USA" },
  { label: "Uruguay", value: "URY" },
  { label: "Uzbekistan", value: "UZB" },
  { label: "Vanuatu", value: "VUT" },
  { label: "Venezuela, Bolivarian Republic of", value: "VEN" },
  { label: "Viet Nam", value: "VNM" },
  { label: "Virgin Islands (British)", value: "VGB" },
  { label: "Virgin Islands (U.S.)", value: "VIR" },
  { label: "Wallis and Futuna", value: "WLF" },
  { label: "Western Sahara", value: "ESH" },
  { label: "Yemen", value: "YEM" },
  { label: "Zambia", value: "ZMB" },
  { label: "Zimbabwe", value: "ZWE" },
];

const financeAnyDegreesName = "experience_in_finance.any_degrees";
const financeDegreesName = "experience_in_finance.degrees";
const financeDegreeDefaultValue = {
  institution: "",
  degree: "",
  date: "",
  documents: [],
};
const financeAnyLicensesName = "experience_in_finance.any_licenses";
const financeLicensesName = "experience_in_finance.licenses";
const financeLicenseDefaultValue = {
  name: "",
  expiry_date: "",
  documents: [],
};
const financeAnyTradingHistoryName = "experience_in_finance.any_trading_history";
const financeTradingHistoryName = "experience_in_finance.trading_history";
const financeOtherName = "experience_in_finance.other";
const financeOtherDocumentsName = "experience_in_finance.other_documents";

const stages = [
  {
    title: "General Information",
    fields: [
      {
        label: "Tax residency",
        name: "general.tax_residency",
        type: "select",
        options: countryOptions,
        required: true,
      },
      {
        label: "Tax number",
        name: "general.tax_number",
        type: "string",
        required: true,
      },
      {
        label: "Mailing address (if different from the address of residence)",
        name: "general.mailing_address",
        type: "textarea",
        paragraph:
          "State / jurisdiction, postal code, town, street / district, house number and if available apartment number",
      },
      {
        label: "Contact phone number",
        name: "general.phone_number",
        type: "phone",
        paragraph: "Include the country code, e.g. +41 44 668 18 00.",
      },
      {
        label: "Purpose and type of your business relationship with the Fund",
        name: "general.purpose",
        type: "textarea",
        paragraph:
          "Investment, long-term savings, income generation, hedging, etc.",
        required: true,
      },
      {
        label: "Sources of income",
        name: "general.income_sources",
        type: "textarea",
        paragraph: "Salary, dividends, income from business activities, etc.",
        required: true,
      },
      {
        label: "Planned initial investment (equivalent in USD)",
        name: "general.investment",
        type: "number",
        required: true,
        min: 50000,
      },
      {
        label: "Documents to verify your income and wealth",
        name: "general.sow",
        type: "documents",
        paragraph:
          "Bank statements, statements from financial institutions detailing holdings, documents showing ownership or equity stakes in businesses",
        required: true,
      },
      {
        label:
          "Are you or any immediate family member a politically exposed person (PEP)?",
        name: "general.pep",
        type: "radiobutton",
        paragraph:
          "PEP is a natural person (including a family member or known associate) who is or has been entrusted with a prominent public function, including but not limited to: a head of state or of government, senior politician, member of a legislative or constitutional assembly, senior government official, senior judicial official, senior military officer, ambassador, senior person in an international organisation, senior executive of a state-owned entity, a senior political party official, or an individual who has been entrusted with similar functions such as a director or a deputy director; at an international, national, or regional level.",
        required: true,
        options: [
          { label: "an official public person", value: "official" },
          { label: "spouse and close relatives", value: "spouse-or-relative" },
          { label: "no", value: "no" },
        ],
      },
      {
        label: "Supplementary documents",
        name: "general.supplementary",
        type: "documents",
        paragraph: "Financial knowledge test results, powers of attorney, etc.",
      },
      {
        label: "Comments for customer support",
        name: "general.comments",
        type: "textarea",
        paragraph:
          "Any information or context you would like the customer support team to know about the documents you submitted",
      },
    ],
  },
  {
    title: "Employment and Business Experience",
    fields: [
      {
        label: "Present occupation",
        name: "employment.occupation",
        type: "string",
      },
      { label: "Salary", name: "employment.salary", type: "string" },
      {
        label: "Do you own your own business or are you otherwise employed?",
        name: "employment.own_business_or_employed",
        type: "textarea",
      },
      {
        label: "Name and type of business employed by or owned",
        name: "employment.business_or_employer",
        type: "textarea",
      },
      {
        label: "Description of responsibilities",
        name: "employment.responsibilities",
        type: "textarea",
      },
      {
        label:
          "Length of service with present employer or length of ownership of present business",
        name: "employment.length_employer",
        type: "string",
      },
      {
        label: "Present title or position",
        name: "employment.position",
        type: "string",
      },
      {
        label: "Length of service in present title or position",
        name: "employment.length_position",
        type: "string",
      },
      {
        label: "CV or other employment record",
        name: "employment.cv",
        type: "documents",
        required: true,
      },
    ],
  },
  {
    title: "Prior Occupations",
    paragraph: "Employment and length of service during the past five years",
    fields: [
      {
        name: "prior_occupations.occupations",
        type: "array",
        addLabel: "Add occupation",
        defaultValue: { occupation: "", name: "", type: "", years: "" },
        fields: [
          {
            label: "Occupation",
            name: "occupation",
            type: "string",
            required: true,
          },
          {
            label: "Name of employer or owned business",
            name: "name",
            type: "string",
            required: true,
          },
          {
            label: "Type",
            name: "type",
            type: "radiobutton",
            required: true,
            options: [
              { label: "Employer", value: "employer" },
              { label: "Owned Business", value: "business" },
            ],
          },
          {
            label: "Years of service",
            name: "years",
            type: "string",
            required: true,
          },
        ],
      },
    ],
  },
  {
    title: "Experience and Knowledge in Finance",
    fields: [
      {
        label:
          "Do you have degrees in finance, economics, accounting, high math, or IT (translated to English and notarized)?",
        name: financeAnyDegreesName,
        type: "boolean_radiobutton",
        required: true,
      },
      {
        name: financeDegreesName,
        type: "array",
        showWhen: { name: financeAnyDegreesName, value: "true" },
        keepFirstWhenShown: true,
        requiredWhenShown: true,
        addLabel: "Add degree",
        defaultValue: financeDegreeDefaultValue,
        fields: [
          {
            label: "Institution",
            name: "institution",
            type: "string",
            required: true,
          },
          { label: "Degree", name: "degree", type: "string", required: true },
          {
            label: "Date of completion",
            name: "date",
            type: "date",
            required: true,
          },
          {
            label: "Diploma",
            name: "documents",
            type: "documents",
            required: true,
          },
        ],
      },
      {
        label:
          "Do you have any professional licenses, registrations, certifications or designations, including bar admissions, accounting certificates, valuation certificates, practising certificates, investment adviser registrations, and qualifications in the AIFC or any jurisdiction or approved person status by the AFSA or other financial services regulator in any jurisdiction (in finance, economics, accounting, high math, or IT)?",
        name: financeAnyLicensesName,
        type: "boolean_radiobutton",
        required: true,
      },
      {
        name: financeLicensesName,
        type: "array",
        showWhen: { name: financeAnyLicensesName, value: "true" },
        keepFirstWhenShown: true,
        requiredWhenShown: true,
        addLabel: "Add license",
        defaultValue: financeLicenseDefaultValue,
        fields: [
          {
            label: "License",
            name: "name",
            type: "string",
            required: true,
          },
          {
            label: "Expiry date",
            name: "expiry_date",
            type: "date",
            required: true,
          },
          {
            label: "Document",
            name: "documents",
            type: "documents",
            required: true,
          },
        ],
      },
      {
        label: "Do you have any trading history within the last 24 months?",
        name: financeAnyTradingHistoryName,
        type: "boolean_radiobutton",
        required: true,
      },
      {
        label: "Trading history",
        name: financeTradingHistoryName,
        type: "documents",
        showWhen: { name: financeAnyTradingHistoryName, value: "true" },
        required: true,
      },
      {
        label:
          "Please describe any additional information that reflects your knowledge and experience in business, financial, or investment matters and your ability to evaluate the merits and risks of this investment:",
        name: financeOtherName,
        type: "textarea",
      },
      {
        label: "Other relevant documents",
        name: financeOtherDocumentsName,
        type: "documents",
      },
    ],
  },
  {
    title: "Current Investment Objectives",
    fields: [
      {
        label: "Current income",
        name: "investment_objectives.income",
        type: "radiobutton",
        required: true,
        options: priorityOptions,
      },
      {
        label: "Appreciation",
        name: "investment_objectives.appreciation",
        type: "radiobutton",
        required: true,
        options: priorityOptions,
      },
      {
        label: "Tax Shelter",
        name: "investment_objectives.tax_shelter",
        type: "radiobutton",
        required: true,
        options: priorityOptions,
      },
      {
        label: "Other",
        name: "investment_objectives.other",
        type: "textarea",
      },
    ],
  },
  {
    title: "Assessed Professional Client",
    paragraph:
      "I am an Assessed Professional Client (as defined in Rule 2.5.1 of the AIFC COB enacted under the AIFC Financial Services Framework Regulations No. 18 of 2017) because (check all appropriate descriptions that apply):",
    fields: [
      {
        label:
          "I am a Client who has net assets of at least USD 100,000 (for this purposes, the calculation of my net assets, the value of my primary residence is excluded and includes any assets held directly or indirectly by me);",
        name: "professional_client.net",
        type: "checkbox",
        required: true,
      },
      {
        label:
          "I have a sufficient experience and understanding of the participating shares in investment companies with variable share capital, subscription agreements, and all related financial products, financial services, transactions and any associated risks;",
        name: "professional_client.understanding",
        type: "checkbox",
      },
      {
        label:
          "I work or have worked in the previous two years in an Authorised Firm or any other authorised or regulated financial institution, including a bank, securities firm or insurance company, in a position that requires knowledge of the type of financial produces, financial services or transactions envisaged.",
        name: "professional_client.work",
        type: "checkbox",
      },
      {
        type: "paragraph",
        text: "I wish to be treated as a Professional Client either (check all appropriate descriptions that apply):",
      },
      {
        label: "generally;",
        name: "professional_client.generally",
        type: "checkbox",
      },
      {
        label:
          "in respect of the Participating Shares in and commitment to the Fund, the management of the Fund and its assets, and the entry into and performance and variation of the Subscription Agreement, subscribing to any additional Participating Shares, making any Additional Investment Amounts, receiving distributions (if any) or redeeming Participating Shares, and transferring the Participating Shares or being prohibited from making such transfer;",
        name: "professional_client.shares",
        type: "checkbox",
      },
      {
        label:
          "in respect of a unit in and commitment to an entity which is a collective investment scheme, the management of an entity, which is a collective investment scheme and its assets, and the entry into and performance and variation of a subscription agreement, subscribing to any additional units or increasing a commitment and making additional contributions to an entity, receiving distributions or making redemptions of and transferring a unit or being prohibited from making such transfer.",
        name: "professional_client.unit",
        type: "checkbox",
      },
    ],
  },
  {
    title: "Manner of Solicitation",
    fields: [
      {
        label:
          "Please state the manner in which you became aware of the investment (for example, by personal contact or acquaintance with an investment advisor or counselor, with Fund Manager personnel, a broker-dealer, or otherwise):",
        name: "solicitation.manner",
        type: "string",
        required: true,
      },
      {
        label: "Name of the contact person",
        name: "solicitation.name",
        type: "string",
        required: true,
      },
      {
        label: "Date",
        name: "solicitation.date",
        type: "date",
        required: true,
      },
    ],
  },
];


const booleanRadiobuttonFieldNames = new Set([
  financeAnyDegreesName,
  financeAnyLicensesName,
  financeAnyTradingHistoryName,
]);

function handleBooleanArrayToggle({
  arrayName,
  clearErrors,
  defaultValue,
  getPath,
  setValue,
  toggleName,
  values,
}) {
  clearErrors(arrayName);

  if (getPath(values, toggleName) === "true") {
    if ((getPath(values, arrayName) || []).length === 0) {
      setValue(arrayName, [{ ...defaultValue }], {
        shouldDirty: true,
        shouldTouch: true,
        shouldValidate: false,
      });
    }
  } else {
    setValue(arrayName, [], {
      shouldDirty: true,
      shouldTouch: true,
      shouldValidate: false,
    });
  }
}

const config = {
  stages,
  requiredGroups: professionalClientRequiredGroups,
  booleanRadiobuttonFieldNames,
  normalizeFieldValue(name, _value, values) {
    const getPath = (object, path) =>
      path.split(".").reduce((current, key) => current?.[key], object);

    if (
      (name === financeDegreesName &&
        getPath(values, financeAnyDegreesName) !== "true") ||
      (name === financeLicensesName &&
        getPath(values, financeAnyLicensesName) !== "true") ||
      (name === financeTradingHistoryName &&
        getPath(values, financeAnyTradingHistoryName) !== "true")
    ) {
      return { handled: true, value: [] };
    }

    return null;
  },
  onFieldChange({ clearErrors, getPath, name, setValue, values }) {
    if (name === financeAnyDegreesName) {
      handleBooleanArrayToggle({
        arrayName: financeDegreesName,
        clearErrors,
        defaultValue: financeDegreeDefaultValue,
        getPath,
        setValue,
        toggleName: financeAnyDegreesName,
        values,
      });
    }

    if (name === financeAnyLicensesName) {
      handleBooleanArrayToggle({
        arrayName: financeLicensesName,
        clearErrors,
        defaultValue: financeLicenseDefaultValue,
        getPath,
        setValue,
        toggleName: financeAnyLicensesName,
        values,
      });
    }

    if (name === financeAnyTradingHistoryName) {
      clearErrors(financeTradingHistoryName);

      if (getPath(values, financeAnyTradingHistoryName) !== "true") {
        setValue(financeTradingHistoryName, [], {
          shouldDirty: true,
          shouldTouch: true,
          shouldValidate: false,
        });
      }
    }
  },
};

document.addEventListener(
  "DOMContentLoaded",
  () => mountOnboardingForm("kyc", config),
  false,
);
